<template>
    <div class="h-full">
        <div class="hidden md:flex justify-end items-center px-4 lg:px-8 py-4">
            <ProfileDropdown
                :authUser="authUser"
                :authCompanyUser="authCompanyUser"
                :impersonating="impersonating"
            />
        </div>
        <div class="hidden md:block px-4 lg:px-8">
            <div class="border-b border-stone-200"></div>
        </div>
        <div class="px-4 lg:px-8 py-4 space-y-4">
            <span
                v-if="pageMeta?.pageTitle"
                class="font-bold text-2xl lg:text-3xl"
            >
                {{ pageMeta.pageTitle }}
            </span>

            <div
                v-if="slots.left || slots.right"
                class="flex justify-between items-center gap-2"
            >
                <div v-if="slots.left">
                    <slot name="left" />
                </div>
                <div v-else></div>

                <div v-if="slots.right">
                    <slot name="right" />
                </div>
                <div v-else></div>
            </div>
            <div>
                <PageContent>
                    <slot />
                </PageContent>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'
    import PageContent from '@/Shared/Layout/App/Sidebar/PageContent.vue'
    import ProfileDropdown from '@/Shared/Component/ProfileDropdown.vue'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'
    import User from '@/App/User/Entity/User'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'

    interface PageWrapperProps {
        pageMeta: PageMeta | null
        authUser: User
        authCompanyUser: CompanyUser
        impersonating: boolean
    }

    const props = defineProps<PageWrapperProps>()
    const slots: any = useSlots()
</script>
